export default "__VITE_ASSET__Q7srjc2c__"